import { zeroPad } from 'react-countdown';

export default function CountdownRenderer({ hours, minutes, seconds }) {
  const minutesAndSeconds = `${zeroPad(minutes)}:${zeroPad(seconds)}`;
  if (!hours) {
    return minutesAndSeconds;
  }
  return `${zeroPad(hours)}:${minutesAndSeconds}`;
}
